<div class="sla-settings">
  <app-ui-page-header
    title="Pol&iacute;ticas de SLA"
    subtitle="Defina em quanto tempo cada tipo de resposta deve sair. O painel mede a ades&atilde;o por estas metas."
    density="compact"
  />

  <form appUiPanelCard class="sla-settings__create" (submit)="$event.preventDefault(); create()">
    <input appInput type="text" placeholder="Nome da pol&iacute;tica" [formControl]="nameControl" />
    <div class="sla-settings__check">
      <button
        appCheckbox
        type="button"
        [ngpCheckboxChecked]="makeDefaultControl.value"
        (ngpCheckboxCheckedChange)="makeDefaultControl.setValue($event)"
        aria-label="Criar como pol&iacute;tica padr&atilde;o"
      >
        <ng-icon name="heroCheck" size="13" aria-hidden="true" class="opacity-0 transition-opacity group-data-[checked]:opacity-100" />
      </button>
      <span>Padr&atilde;o</span>
    </div>
    <button appButton variant="primary" size="sm" type="submit" [disabled]="saving() || nameControl.value.trim().length === 0">Criar</button>
  </form>

  @if (rows().length > 0) {
    <ul appUiRecordList>
      @for (row of rows(); track row.policy.id) {
        <li appUiRecordRow [interactive]="false" [class.sla-settings__item--inactive]="!row.policy.isActive">
          <span appUiRecordRowMain>
            <span appUiRecordRowBody>
              <span appUiRecordRowTitle>{{ row.policy.name }}</span>
              <span appUiRecordRowDescription>
                @for (slot of slots; track slot.key) {
                  <span class="sla-settings__target">{{ slot.label }}: <b>{{ targetOf(row, slot) }}</b></span>
                }
              </span>
            </span>
          </span>

          <span appUiRecordRowMeta>
            @if (row.policy.isDefault) {
              <span appBadge tone="accent" size="xs">Padr&atilde;o</span>
            }
            @if (!row.policy.isActive) {
              <span appBadge tone="neutral" size="xs">Inativa</span>
            }
          </span>

          <span appUiRecordRowActions>
            <button appButton variant="ghost" size="sm" type="button" (click)="openTargets(row)">Editar metas</button>
            @if (!row.policy.isDefault) {
              <button appButton variant="ghost" size="sm" type="button" (click)="makeDefaultPolicy(row.policy)">Tornar padr&atilde;o</button>
            }
            <button appButton variant="ghost" size="sm" type="button" (click)="toggleActive(row.policy)">
              {{ row.policy.isActive ? 'Desativar' : 'Ativar' }}
            </button>
          </span>
        </li>

        @if (editing() === row.policy.id) {
          <li appUiRecordRow [interactive]="false" class="sla-settings__editor">
            <div class="sla-settings__grid">
              @for (slot of slots; track slot.key) {
                <label class="sla-settings__field">
                  <span appUiLabel>{{ slot.label }}</span>
                  <span class="sla-settings__inputwrap">
                    <input
                      appInput
                      type="number"
                      min="1"
                      inputmode="numeric"
                      [formControl]="targetControls[slot.key]!"
                      [attr.aria-label]="slot.label + ' em ' + slot.unitLabel"
                    />
                    <span class="sla-settings__unit">{{ slot.unitLabel }}</span>
                  </span>
                  <span class="sla-settings__hint">{{ slot.hint }}</span>
                </label>
              }
            </div>
            <p class="sla-settings__note">
              Campo em branco significa <b>sem meta</b> para aquela combina&ccedil;&atilde;o: o tempo continua sendo medido e
              entra na m&eacute;dia, mas o turno n&atilde;o conta para a ades&atilde;o. O tempo &eacute; contado em
              <b>hor&aacute;rio comercial</b>, pelo calend&aacute;rio da pol&iacute;tica.
            </p>
            <div class="sla-settings__editor-actions">
              <button appButton variant="secondary" size="sm" type="button" (click)="closeTargets()">Cancelar</button>
              <button appButton variant="primary" size="sm" type="button" [disabled]="saving()" (click)="saveTargets(row.policy.id)">
                Salvar metas
              </button>
            </div>
          </li>
        }
      }
    </ul>
  } @else if (loading()) {
    <!-- Skeleton em vez de área em branco: sem ele o gestor começava a digitar um nome e as
         políticas existentes apareciam por baixo. -->
    <app-ui-skeleton-grid [rows]="3" [rowHeight]="64" />
  } @else if (error(); as motivo) {
    <!-- ANTES do empty state: sem este ramo, falha de leitura caía em "nenhuma política criada",
         afirmando um fato falso sobre o sistema. -->
    <app-ui-empty-state
      title="N&atilde;o foi poss&iacute;vel carregar as pol&iacute;ticas"
      [description]="motivo"
    >
      <button appButton variant="secondary" size="sm" type="button" (click)="retry()" actions>Tentar novamente</button>
    </app-ui-empty-state>
  } @else {
    <app-ui-empty-state
      title="Nenhuma pol&iacute;tica de SLA criada"
      description="Crie uma pol&iacute;tica para definir metas de resposta e acompanhar a ades&atilde;o no painel."
    />
  }
</div>
